// extracted by mini-css-extract-plugin
export default {"card":"Card_card__YzZy4","card__heading":"Card_card__heading__tSeiB","card__heading_title":"Card_card__heading_title__B90fW","card__description":"Card_card__description__0WjgM"};